import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import AuthContext from "../Context/AuthProvider";
import { getMyAssignedServices } from "../API/LinkedServicesApi";
import { getAllAssignedServices } from "../API/AllAssignedServicesApi";
import { useSnackbar } from "../Utility/UserMessageContext";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid2,
  Typography,
  Chip,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  CheckCircleOutline,
  HourglassTop,
  MedicalServices,
  Visibility,
  Download,
  Close,
  PlayCircleOutline,
  PeopleOutline,
  EventBusy,
  WarningAmber,
} from "@mui/icons-material";
import dayjs from "dayjs";
import DateRangeDialog from "../Appointments/ChangeDates";
import {
  convertToUTC,
  convertUTCToTimeZoneDateTimeString,
} from "../Utility/DateTimeUtility";
import { getDisplayValue } from "../Utility/Utility";
import { DateRangeOptions, ServiceStatus } from "../Utility/Constants";
import MenuBar from "../common/MenuBar";
import { UserRolesConstants } from "../Utility/Constants";
import Chart from "chart.js/auto";
import { useTheme, useMediaQuery } from "@mui/material";
import { exportPDF } from "../Utility/PdfConverterForReport";

// ─── Chart.js global instances ───────────────────────────────────────────────
let chartInstances = {};

// ─── Colors ──────────────────────────────────────────────────────────────────
const C = {
  teal: "#1D9E75",
  tealL: "#E1F5EE",
  coral: "#D85A30",
  coralL: "#FAECE7",
  blue: "#378ADD",
  blueL: "#E6F1FB",
  amber: "#BA7517",
  amberL: "#FAEEDA",
  purple: "#7F77DD",
  purpleL: "#EEEDFE",
  green: "#639922",
  greenL: "#EAF3DE",
  pink: "#D4537E",
  pinkL: "#FBEAF0",
};

// ─── CSV Download ─────────────────────────────────────────────────────────────
function downloadCSV(rows, columns, filename) {
  const header = columns.map((c) => c.headerName).join(",");
  const body = rows.map((row) =>
    columns
      .map((c) => `"${String(row[c.field] ?? "").replace(/"/g, '""')}"`)
      .join(","),
  );
  const blob = new Blob([[header, ...body].join("\n")], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
}

// ─── Table Dialog ─────────────────────────────────────────────────────────────

function TableDialog({ open, onClose, title, rows, columns, csvFilename ,auth, filters}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // const handleDownloadPdf = () => {
  //   // Simple print-based PDF
  //   const printWindow = window.open("", "_blank");
  //   const header = columns
  //     .map(
  //       (c) =>
  //         `<th style="border:1px solid #ccc;padding:6px 10px;background:#f5f5f5">${c.headerName}</th>`,
  //     )
  //     .join("");
  //   const body = rows
  //     .map(
  //       (row) =>
  //         `<tr>${columns.map((c) => `<td style="border:1px solid #ccc;padding:5px 10px">${row[c.field] ?? ""}</td>`).join("")}</tr>`,
  //     )
  //     .join("");
  //   printWindow.document.write(`
  //     <html><head><title>${title}</title>
  //     <style>body{font-family:Arial,sans-serif;font-size:12px;padding:16px}
  //     table{border-collapse:collapse;width:100%}
  //     h2{margin-bottom:12px}</style></head>
  //     <body>
  //       <h2>${title}</h2>
  //       <table><thead><tr>${header}</tr></thead><tbody>${body}</tbody></table>
  //       <script>window.onload=()=>{window.print();window.close()}<\/script>
  //     </body></html>
  //   `);
  //   printWindow.document.close();
  // };
const handleDownloadPdf = () => {
  exportPDF(
    rows,
    columns,
    filters?.from?.toISOString() || null,
    filters?.to?.toISOString() || null,
    title,
    auth?.selectedFacility?.logo
  );
};
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 0,
          px: 0,
        }}
      >
        <MenuBar showDownload={true} onDownload={handleDownloadPdf} />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, pr: 1 }}>
          {/* <Typography variant="subtitle1" fontWeight={600}>{title}</Typography> */}
          <IconButton size="small" onClick={onClose}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 0, height: 460 }}>
        {isMobile ? (
          // Mobile Card View
          <Box sx={{ px: 1, py: 1, maxHeight: 460, overflowY: "auto" }}>
            {rows.map((row, idx) => (
              <Card
                key={row.id || idx}
                variant="outlined"
                sx={{ mb: 1.5, borderRadius: 2 }}
              >
                <CardContent sx={{ py: 1, px: 1.5, "&:last-child": { pb: 1 } }}>
                  {columns.map((col) =>
                    row[col.field] !== undefined &&
                    row[col.field] !== null &&
                    row[col.field] !== "" ? (
                      <Box
                        key={col.field}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 0.5,
                        }}
                      >
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          fontWeight={600}
                          sx={{ minWidth: 90, fontSize: "0.7rem" }}
                        >
                          {col.headerName}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            fontSize: "0.72rem",
                            textAlign: "right",
                            flex: 1,
                          }}
                        >
                          {String(row[col.field])}
                        </Typography>
                      </Box>
                    ) : null,
                  )}
                </CardContent>
              </Card>
            ))}
          </Box>
        ) : (
          // Desktop DataGrid View
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              density: "compact",
              pagination: { paginationModel: { pageSize: 20 } },
            }}
            pageSizeOptions={[10, 20, 50]}
            sx={{
              border: "none",
              height: 460,
              "& .MuiTablePagination-toolbar": {
                minHeight: "unset",
                alignItems: "center",
              },
              "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                { margin: 0 },
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

// ─── Stat Card ────────────────────────────────────────────────────────────────
function StatCard({ icon, label, value, color, bgColor, subtitle, onView }) {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        border: `1.5px solid ${bgColor}`,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent
        sx={{
          padding: "12px 14px !important",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: 0.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: 1.5,
              background: bgColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {React.cloneElement(icon, { sx: { fontSize: 15, color } })}
          </Box>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight={500}
            sx={{ lineHeight: 1.2, fontSize: "0.68rem" }}
          >
            {label}
          </Typography>
        </Box>
        <Typography
          variant="h4"
          fontWeight={700}
          sx={{ color, lineHeight: 1, mt: 0.5 }}
        >
          {value}
        </Typography>
        {subtitle && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontSize: "0.62rem", lineHeight: 1.3 }}
          >
            {subtitle}
          </Typography>
        )}
        <Box sx={{ flex: 1 }} />
        {onView && (
          <Box sx={{ mt: 1 }}>
            <Button
              size="small"
              variant="contained"
              startIcon={<Visibility sx={{ fontSize: "11px !important" }} />}
              onClick={onView}
              sx={{
                fontSize: "0.62rem",
                py: 0.25,
                px: 1,
                minHeight: 0,
                lineHeight: 1.4,
                background: color,
                "&:hover": { background: color, opacity: 0.88 },
                borderRadius: 1,
              }}
            >
              VIEW
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

// ─── Warning Card ─────────────────────────────────────────────────────────────
function WarningCard({
  overdueCount,
  stalledCount,
  onViewOverdue,
  onViewStalled,
}) {
  const hasWarning = overdueCount > 0 || stalledCount > 0;
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        border: hasWarning ? `1.5px solid #FFB74D` : `1.5px solid #E1F5EE`,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: hasWarning ? "#FFFBF2" : "#fff",
      }}
    >
      <CardContent
        sx={{
          padding: "12px 14px !important",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          gap: 0.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: 1.5,
              background: hasWarning ? "#FFF3E0" : "#E1F5EE",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <WarningAmber
              sx={{ fontSize: 15, color: hasWarning ? "#E65100" : "#1D9E75" }}
            />
          </Box>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight={500}
            sx={{ lineHeight: 1.2, fontSize: "0.68rem" }}
          >
            Attention Required
          </Typography>
        </Box>

        {!hasWarning ? (
          <Typography
            variant="body2"
            fontWeight={600}
            sx={{ color: C.green, mt: 0.5 }}
          >
            All clear ✓
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.75,
              mt: 0.5,
            }}
          >
            {overdueCount > 0 && (
              <Box
                onClick={onViewOverdue}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  background: "#FFF3E0",
                  border: "1px solid #FFB74D",
                  cursor: "pointer",
                  "&:hover": { background: "#FFE0B2" },
                }}
              >
                <EventBusy
                  sx={{ fontSize: 13, color: "#E65100", flexShrink: 0 }}
                />
                <Typography
                  variant="caption"
                  fontWeight={600}
                  sx={{
                    color: "#E65100",
                    fontSize: "0.62rem",
                    lineHeight: 1.3,
                  }}
                >
                  {overdueCount} overdue — not started
                </Typography>
              </Box>
            )}
            {stalledCount > 0 && (
              <Box
                onClick={onViewStalled}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  background: "#FDE8E8",
                  border: "1px solid #E57373",
                  cursor: "pointer",
                  "&:hover": { background: "#FFCDD2" },
                }}
              >
                <HourglassTop
                  sx={{ fontSize: 13, color: "#C62828", flexShrink: 0 }}
                />
                <Typography
                  variant="caption"
                  fontWeight={600}
                  sx={{
                    color: "#C62828",
                    fontSize: "0.62rem",
                    lineHeight: 1.3,
                  }}
                >
                  {stalledCount} stalled — scheduled before today
                </Typography>
              </Box>
            )}
          </Box>
        )}
        <Box sx={{ flex: 1 }} />
      </CardContent>
    </Card>
  );
}

// ─── Section Card ─────────────────────────────────────────────────────────────
function SectionCard({ title, icon, color, children, onViewAll }) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
      <CardHeader
        title={
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {icon && React.cloneElement(icon, { sx: { fontSize: 14, color } })}
            <Typography
              variant="body2"
              fontWeight={600}
              color="text.secondary"
              sx={{
                textTransform: "uppercase",
                fontSize: "0.68rem",
                letterSpacing: 0.5,
              }}
            >
              {title}
            </Typography>
          </Box>
        }
        action={
          onViewAll && (
            <Button
              size="small"
              startIcon={<Visibility sx={{ fontSize: 12 }} />}
              onClick={onViewAll}
              sx={{ fontSize: "0.68rem", py: 0.2, color }}
            >
              View All
            </Button>
          )
        }
        sx={{ pb: 0, pt: 1.5, px: 2 }}
      />
      <CardContent sx={{ pt: 1, pb: "12px !important" }}>
        {children}
      </CardContent>
    </Card>
  );
}

// ─── Canvas wrapper ───────────────────────────────────────────────────────────
function ChartBox({ id, height = 180, label, minWidth }) {
  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <Box sx={{ position: "relative", height, minWidth: minWidth || "100%" }}>
        <canvas id={id} role="img" aria-label={label}>{label}</canvas>
      </Box>
    </Box>
  );
}

// ─── Service table columns ────────────────────────────────────────────────────
const makeServiceCols = (auth) => [
  { field: "displayId", headerName: "Service ID", width: 140 },
  {
    field: "patient",
    headerName: "Patient",
    width: 200,
    valueGetter: (_, r) =>
      `${r.patientPrefix || ""} ${r.patientFirstName || ""} ${r.patientLastName || ""}`.trim(),
  },
  { field: "patientMobileNo", headerName: "Mobile", width: 130 },
  { field: "serviceName", headerName: "Service", width: 200 },
  {
    field: "status",
    headerName: "Status",
    width: 130,
    valueGetter: (_, r) => getDisplayValue(r.status),
  },
  {
    field: "scheduledStartDateTime",
    headerName: "Scheduled",
    width: 180,
    valueGetter: (_, r) =>
      convertUTCToTimeZoneDateTimeString(
        r.scheduledStartDateTime,
        auth?.selectedFacility?.timeZone,
      ),
  },
  { field: "visitDisplayId", headerName: "Visit #", width: 130 },
];

const serviceCols = [
  { field: "id", headerName: "#", width: 60 },
  { field: "name", headerName: "Service Type", width: 280 },
  { field: "count", headerName: "Total", width: 100 },
];

const physicianCols = [
  { field: "id", headerName: "#", width: 60 },
  { field: "name", headerName: "Physician", width: 220 },
  { field: "count", headerName: "Total", width: 90 },
  { field: "completed", headerName: "Completed", width: 110 },
  { field: "inProgress", headerName: "In Progress", width: 110 },
  { field: "notStarted", headerName: "Not Started", width: 110 },
];

// ════════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ════════════════════════════════════════════════════════════════════════════════
export default function WorklistDashboard() {
  const { auth } = useContext(AuthContext);
  const { showSnackbar } = useSnackbar();

  // ── Role detection ────────────────────────────────────────────────────────
  // TODO: replace "FacilityAdmin" / "Physician" with exact strings from auth.roles
  const isAdmin = auth?.roles?.includes(UserRolesConstants.FacilityAdmin);
  const isPhysician = auth?.roles?.includes(UserRolesConstants.Physician);
  const isBoth = isAdmin && isPhysician;

  // Toggle only relevant when user has both roles
  // default: if admin-only → "all"; if physician-only or both → "my"
  const [taskView, setTaskView] = useState(() => {
    if (isAdmin && !isPhysician) return "all";
    return "my";
  });

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDateDlg, setOpenDateDlg] = useState(false);
  // const [chartReady, setChartReady]   = useState(false);
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    rows: [],
    columns: [],
    csv: "data.csv",
  });
  const [groupBy, setGroupBy] = useState("daily");

  const closeDialog = () => setDialog((d) => ({ ...d, open: false }));

  const [filters, setFilters] = useState({
    from: dayjs(new Date()),
    to: dayjs(new Date()),
    selectedDateRangeOption: DateRangeOptions.Today,
    statusList: [],
  });

  // Load Chart.js from CDN
  // useEffect(() => {
  //   if (window.Chart) { setChartReady(true); return; }
  //   const s = document.createElement("script");
  //   s.src = "https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.1/chart.umd.js";
  //   s.onload = () => setChartReady(true);
  //   document.head.appendChild(s);
  // }, []);

  const fetchServices = useCallback(async () => {
    setLoading(true);
    const from = convertToUTC(
      dayjs(filters.from)
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .set("millisecond", 0),
    );
    const to = convertToUTC(
      dayjs(filters.to)
        .set("hour", 23)
        .set("minute", 59)
        .set("second", 59)
        .set("millisecond", 999),
    );

    // ── API choice based on role + toggle ────────────────────────────────
    let result;
    if (taskView === "all") {
      result = await getAllAssignedServices(auth, from, to);
    } else {
      result = await getMyAssignedServices(auth, from, to);
    }

if (result?.isSuccess) {
  setServices(result.data || []);
} else if (result && !result.isSuccess) {
  setServices([]);
  showSnackbar("Failed to load dashboard data", "error");
}
setLoading(false);
  }, [auth, filters, taskView]);

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  // ── Metrics ───────────────────────────────────────────────────────────────
  const m = useMemo(() => {
    const total = services.length;
    const notStarted = services.filter(
      (s) => s.status === ServiceStatus.NotStarted,
    );
    const inProgress = services.filter(
      (s) => s.status === ServiceStatus.InProgress,
    );
    const completed = services.filter(
      (s) => s.status === ServiceStatus.Completed,
    );

    const serviceTypeMap = {};
    services.forEach((s) => {
      const name = s.serviceName || "Unknown";
      serviceTypeMap[name] = (serviceTypeMap[name] || 0) + 1;
    });
    const serviceTypeData = Object.entries(serviceTypeMap)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 6);
    const serviceTypeTableRows = Object.entries(serviceTypeMap)
      .sort((a, b) => b[1] - a[1])
      .map(([name, count], i) => ({ id: i + 1, name, count }));

    const statusEntries = [
      ["Completed", completed.length],
      ["In Progress", inProgress.length],
      ["Not Started", notStarted.length],
    ].filter(([, v]) => v > 0);

    const dateMap = {};
    services.forEach((s) => {
      if (s.scheduledStartDateTime) {
        const d = dayjs(s.scheduledStartDateTime).format("DD MMM");
        dateMap[d] = (dateMap[d] || 0) + 1;
      }
    });

    const chartLabels = [],
      chartValues = [],
      chartDateGroups = {};

   if (groupBy === "hourly") {
  // 0-23 hours
  const hourMap = {};
  services.forEach((s) => {
    if (s.scheduledStartDateTime) {
      const h = dayjs(s.scheduledStartDateTime).format("HH:00");
      hourMap[h] = (hourMap[h] || 0) + 1;
    }
  });
  for (let h = 0; h < 24; h++) {
    const lbl = `${String(h).padStart(2, "0")}:00`;
    chartLabels.push(lbl);
    chartValues.push(hourMap[lbl] || 0);
    chartDateGroups[lbl] = services.filter((s) => {
      if (!s.scheduledStartDateTime) return false;
      return dayjs(s.scheduledStartDateTime).format("HH:00") === lbl;
    });
  }
} else if (groupBy === "daily") {

      let c = filters.from.clone();
      while (c.isBefore(filters.to) || c.isSame(filters.to, "day")) {
        const lbl = c.format("DD MMM");
        chartLabels.push(lbl);
        chartValues.push(dateMap[lbl] || 0);
        chartDateGroups[lbl] = services.filter(
          (s) =>
            s.scheduledStartDateTime &&
            dayjs(s.scheduledStartDateTime).format("DD MMM") === lbl,
        );
        c = c.add(1, "day");
      }
    } else if (groupBy === "weekly") {
      let ws = filters.from.clone().startOf("week");
      while (ws.isBefore(filters.to)) {
        const we = ws.add(6, "day");
        const weekServices = services.filter((s) => {
          if (!s.scheduledStartDateTime) return false;
          const d = dayjs(s.scheduledStartDateTime);
          return (
            (d.isAfter(ws) || d.isSame(ws, "day")) &&
            (d.isBefore(we) || d.isSame(we, "day"))
          );
        });
        // ── label: "22 Feb - 28 Feb" ──
        const lbl = `${ws.format("DD MMM")} - ${we.format("DD MMM")}`;
        chartLabels.push(lbl);
        chartValues.push(weekServices.length);
        chartDateGroups[lbl] = weekServices;
        ws = ws.add(7, "day");
      }
    } else if (groupBy === "monthly") {
      let ms = filters.from.clone().startOf("month");
      while (ms.isBefore(filters.to)) {
        const lbl = ms.format("MMM YYYY");
        const monthServices = services.filter((s) => {
          if (!s.scheduledStartDateTime) return false;
          return dayjs(s.scheduledStartDateTime).format("MMM YYYY") === lbl;
        });
        chartLabels.push(lbl);
        chartValues.push(monthServices.length);
        chartDateGroups[lbl] = monthServices;
        ms = ms.add(1, "month");
      }
    }

    const completionRate =
      total > 0 ? ((completed.length / total) * 100).toFixed(1) : 0;

    const now = dayjs();
    const todayStart = now.startOf("day");

    const overdueNotStarted = services.filter((s) => {
      if (s.status !== ServiceStatus.NotStarted) return false;
      if (!s.scheduledStartDateTime) return false;
      return dayjs(s.scheduledStartDateTime).isBefore(now); // now = current time
    });

    const stalledInProgress = services.filter((s) => {
      if (s.status !== ServiceStatus.InProgress) return false;
      if (!s.scheduledStartDateTime) return false;
      return dayjs(s.scheduledStartDateTime).isBefore(todayStart);
    });

    const physicianMap = {};
    services.forEach((s) => {
      const name = s.assignedToUserName?.trim() || "Unassigned";
      if (!physicianMap[name]) {
        physicianMap[name] = {
          total: 0,
          completed: 0,
          inProgress: 0,
          notStarted: 0,
        };
      }
      physicianMap[name].total++;
      if (s.status === ServiceStatus.Completed) physicianMap[name].completed++;
      if (s.status === ServiceStatus.InProgress)
        physicianMap[name].inProgress++;
      if (s.status === ServiceStatus.NotStarted)
        physicianMap[name].notStarted++;
    });
    const physicianData = Object.entries(physicianMap)
      .sort((a, b) => b[1].total - a[1].total)
      .slice(0, 6);
    const physicianTableRows = Object.entries(physicianMap)
      .sort((a, b) => b[1].total - a[1].total)
      .map(([name, d], i) => ({
        id: i + 1,
        name,
        count: d.total,
        completed: d.completed,
        inProgress: d.inProgress,
        notStarted: d.notStarted,
      }));

    return {
      total,
      notStarted,
      inProgress,
      completed,
      serviceTypeData,
      serviceTypeTableRows,
      chartLabels,
      chartValues,
      chartDateGroups,
      statusEntries,
      completionRate,
      overdueNotStarted,
      stalledInProgress,
      physicianData,
      physicianTableRows,
    };
  }, [services, groupBy, filters]);

  const svcCols = useMemo(() => makeServiceCols(auth), [auth]);

  const openServiceDlg = useCallback(
    (title, rows, csv) =>
      setDialog({
        open: true,
        title,
        rows: rows.map((s, i) => ({ ...s, id: s.id || i })),
        columns: svcCols,
        csv,
      }),
    [svcCols],
  );

  const openServiceDlgRef = React.useRef(openServiceDlg);
  useEffect(() => {
    openServiceDlgRef.current = openServiceDlg;
  });
  const mRef = React.useRef(m);
  useEffect(() => {
    mRef.current = m;
  });
  const chartDateGroupsRef = React.useRef(m.chartDateGroups);
  useEffect(() => {
    chartDateGroupsRef.current = m.chartDateGroups;
  });

  // ── Charts ────────────────────────────────────────────────────────────────
  useEffect(() => {
    // if (!chartReady || loading) return;
    // const Chart = window.Chart;
    // if (!Chart) return;
    if (loading) return;

    const destroy = (id) => {
      if (chartInstances[id]) {
        chartInstances[id].destroy();
        delete chartInstances[id];
      }
    };

    const hEl = document.getElementById("wd-hourly");
    if (hEl && m.chartLabels.length > 0) {
      destroy("hourly");
      const maxVal = Math.max(...m.chartValues, 1);
      chartInstances["hourly"] = new Chart(hEl, {
        type: "bar",
        data: {
          labels: m.chartLabels,
          datasets: [
            {
              label: "Services",
              data: m.chartValues,
              backgroundColor: m.chartValues.map((v) => {
                const r = v / maxVal;
                return r >= 0.75
                  ? "#D32F2F" + "CC"
                  : r >= 0.4
                    ? "#F9A825" + "CC"
                    : C.green + "CC";
              }),
              borderColor: m.chartValues.map((v) => {
                const r = v / maxVal;
                return r >= 0.75 ? "#D32F2F" : r >= 0.4 ? "#F9A825" : C.green;
              }),
              borderWidth: 1,
              borderRadius: 4,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  const v = ctx.raw;
                  const r = v / maxVal;
                  const traffic =
                    r >= 0.75 ? "🔴 High" : r >= 0.4 ? "🟡 Medium" : "🟢 Low";
                  return ` ${v} services  ${traffic}`;
                },
              },
            },
          },
          scales: {
   x: {
  ticks: {
    font: { size: 9 },
    maxRotation: 45,
    autoSkip: false,      // ← koi bhi date skip mat karo
    maxTicksLimit: undefined, // ← limit hatao
  },
  grid: { display: false },
},
            y: {
              beginAtZero: true,
              ticks: { font: { size: 10 }, stepSize: 1 },
              grid: { color: "rgba(0,0,0,0.04)" },
            },
          },
          onClick: (evt, elements) => {
            if (!elements.length) return;
            const idx = elements[0].index;
            const lbl = m.chartLabels[idx];
            const rows = chartDateGroupsRef.current[lbl] || [];
            if (rows.length > 0) {
              openServiceDlgRef.current(
                `Services — ${lbl}`,
                rows,
                `services_${lbl}.csv`,
              );
            }
          },
        },
      });
    }

    const stEl = document.getElementById("wd-status");
    if (stEl && m.total > 0) {
      destroy("status");
      chartInstances["status"] = new Chart(stEl, {
        type: "doughnut",
        data: {
          labels: m.statusEntries.map(([k]) => k),
          datasets: [
            {
              data: m.statusEntries.map(([, v]) => v),
              backgroundColor: [C.green, C.blue, C.amber],
              borderWidth: 2,
              borderColor: "#fff",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
              labels: { font: { size: 10 }, padding: 6, boxWidth: 10 },
            },
          },
          cutout: "55%",
          onClick: (evt, elements) => {
            if (!elements.length) return;
            const idx = elements[0].index;
            const label = mRef.current.statusEntries[idx][0];
            if (label === "Completed")
              openServiceDlgRef.current(
                "Completed Services",
                mRef.current.completed,
                "completed_services.csv",
              );
            if (label === "In Progress")
              openServiceDlgRef.current(
                "In Progress Services",
                mRef.current.inProgress,
                "inprogress_services.csv",
              );
            if (label === "Not Started")
              openServiceDlgRef.current(
                "Not Started Services",
                mRef.current.notStarted,
                "notstarted_services.csv",
              );
          },
        },
      });
    }

    return () => Object.keys(chartInstances).forEach(destroy);
  }, [m, loading]);

  const svcColors = [C.teal, C.purple, C.blue, C.coral, C.amber, C.pink];

  // ── Toggle UI ─────────────────────────────────────────────────────────────
  const renderToggle = () => {
    const options = [
      { value: "my", label: "My Tasks" },
      { value: "all", label: "All Tasks" },
    ];

    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          px: 0.5,
          py: 0.25,
        }}
      >
        {options.map((opt) => {
          // disabled logic:
          // only-admin  → "my" disabled
          // only-physician → "all" disabled
          // both → nothing disabled
          const isDisabled = isBoth
            ? false
            : opt.value === "all"
              ? !isAdmin
              : !isPhysician;

          const isActive = taskView === opt.value;

          return (
            <Tooltip
              key={opt.value}
              title={
                isDisabled
                  ? opt.value === "all"
                    ? "Admin access required"
                    : "Physician access required"
                  : ""
              }
              arrow
            >
              <Box
                onClick={() => {
                  if (!isDisabled) setTaskView(opt.value);
                }}
                sx={{
                  px: 1.5,
                  py: 0.25,
                  borderRadius: 1.5,
                  fontSize: "0.72rem",
                  fontWeight: isActive ? 700 : 400,
                  background: isActive ? C.teal : "transparent",
                  color: isDisabled
                    ? "#bdbdbd"
                    : isActive
                      ? "#fff"
                      : "text.secondary",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  transition: "all 0.2s",
                  userSelect: "none",
                  border: isDisabled ? "none" : "none",
                }}
              >
                {opt.label}
              </Box>
            </Tooltip>
          );
        })}
      </Box>
    );
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <Box
      sx={{
        maxHeight: "calc(100vh - 100px)",
        overflowY: "auto",
        background: "#f7f8fa",
      }}
    >
      {/* ── MenuBar ── */}
      <Box sx={{ background: "#fff" }}>
        <MenuBar
          showChangeDate={true}
          onChangeDate={() => setOpenDateDlg(true)}
          showRefresh={true}
          onRefresh={fetchServices}
          refreshDisabled={loading}
          disabled={loading}
        />
        <Box
          sx={{
            px: 1,
            pb: 0.75,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Showing{" "}
            <Box component="span" sx={{ fontWeight: 600 }}>
              {taskView === "all" ? "all tasks" : "my tasks"}
            </Box>{" "}
            from{" "}
            <Box component="span" sx={{ fontWeight: 600 }}>
              {filters.from.format("DD/MM/YYYY")}
            </Box>{" "}
            to{" "}
            <Box component="span" sx={{ fontWeight: 600 }}>
              {filters.to.format("DD/MM/YYYY")}
            </Box>
          </Typography>

          {/* Toggle — always visible, disabled options greyed out */}
          {renderToggle()}
        </Box>
      </Box>

      {/* ── Main content ── */}
      <Box sx={{ px: 2, py: 1.5, position: "relative" }}>
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.6)",
              zIndex: 10,
            }}
          >
            <CircularProgress size={36} sx={{ color: C.teal }} />
          </Box>
        )}

        {/* ── Row 1: Stat Cards ── */}
        <Grid2 container spacing={1.5} sx={{ mb: 2 }}>
  <Grid2 size={{ xs: 6, sm: 6, md: 3.5 }}>
    <StatCard
      icon={<MedicalServices />}
      label="Total Services"
      value={m.total}
      color={C.teal}
      bgColor={C.tealL}
      onView={() => openServiceDlg("All Services", services, "all_services.csv")}
    />
  </Grid2>

  <Grid2 size={{ xs: 6, sm: 6, md: 3.5 }}>
    <WarningCard
      overdueCount={m.overdueNotStarted.length}
      stalledCount={m.stalledInProgress.length}
      onViewOverdue={() => openServiceDlg("Overdue - Not Started", m.overdueNotStarted, "overdue_notstarted.csv")}
      onViewStalled={() => openServiceDlg("Stalled - In Progress", m.stalledInProgress, "stalled_inprogress.csv")}
    />
  </Grid2>

  {/* Status Split pie — same row */}
  <Grid2 size={{ xs: 12, sm: 12, md: 5 }}>
    <Card variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
      <CardHeader
        title={
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <CheckCircleOutline sx={{ fontSize: 14, color: C.green }} />
            <Typography variant="body2" fontWeight={600} color="text.secondary"
              sx={{ textTransform: "uppercase", fontSize: "0.68rem", letterSpacing: 0.5 }}>
              Status Split (click to view)
            </Typography>
          </Box>
        }
        sx={{ pb: 0, pt: 1.5, px: 2 }}
      />
      <CardContent sx={{ pt: 1, pb: "12px !important" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box sx={{ flex: 2, cursor: "pointer" }}>
            <ChartBox id="wd-status" height={140} label="Status distribution doughnut — click to view" />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box
              sx={{ textAlign: "center", cursor: "pointer",paddingRight: 5,  borderRadius: 1, "&:hover": { background: C.greenL } }}
              onClick={() => openServiceDlg("Completed Services", m.completed, "completed_services.csv")}
            >
              <Typography variant="h6" fontWeight={700} sx={{ color: C.green, lineHeight: 1 }}>{m.completed.length}</Typography>
              <Typography variant="caption" color="text.secondary">Completed</Typography>
            </Box>
            <Divider />
            <Box
              sx={{ textAlign: "center", cursor: "pointer", paddingRight: 4.5,  borderRadius: 1, "&:hover": { background: C.blueL } }}
              onClick={() => openServiceDlg("In Progress Services", m.inProgress, "inprogress_services.csv")}
            >
              <Typography variant="h6" fontWeight={700} sx={{ color: C.blue, lineHeight: 1 }}>{m.inProgress.length}</Typography>
              <Typography variant="caption" color="text.secondary">In Progress</Typography>
            </Box>
            <Divider />
            <Box
              sx={{ textAlign: "center", cursor: "pointer", paddingRight: 5, borderRadius: 1, "&:hover": { background: C.amberL } }}
              onClick={() => openServiceDlg("Not Started Services", m.notStarted, "notstarted_services.csv")}
            >
              <Typography variant="h6" fontWeight={700} sx={{ color: C.amber, lineHeight: 1 }}>{m.notStarted.length}</Typography>
              <Typography variant="caption" color="text.secondary">Not Started</Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  </Grid2>
</Grid2>

        {/* ── Row 2: Distribution Chart ── */}
        <Card variant="outlined" sx={{ borderRadius: 2, mb: 2 }}>
          <CardHeader
            title={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body2"
                  fontWeight={600}
                  color="text.secondary"
                  sx={{
                    textTransform: "uppercase",
                    fontSize: "0.68rem",
                    letterSpacing: 0.5,
                  }}
                >
                  Service Distribution
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "#D32F2F",
                    }}
                  />
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: "0.62rem" }}
                  >
                    High
                  </Typography>
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "#F9A825",
                      ml: 0.5,
                    }}
                  />
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: "0.62rem" }}
                  >
                    Medium
                  </Typography>
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "#1D9E75",
                      ml: 0.5,
                    }}
                  />
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: "0.62rem" }}
                  >
                    Low
                  </Typography>
                </Box>
              </Box>
            }
            action={
              <Box sx={{ pr: 1, pt: 0.5 }}>
                <select
                  value={groupBy}
                  onChange={(e) => setGroupBy(e.target.value)}
                  style={{
                    fontSize: "0.72rem",
                    border: "1px solid #e0e0e0",
                    borderRadius: 6,
                    padding: "3px 8px",
                    background: "#fff",
                    cursor: "pointer",
                    outline: "none",
                  }}
                >
                <option value="hourly">Hourly</option>
                  <option value="daily">Daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                </select>
              </Box>
            }
            sx={{ pb: 0, pt: 1.5, px: 2 }}
          />
          <CardContent sx={{ pt: 1, pb: "12px !important" }}>
            {m.chartLabels.length === 0 ? (
              <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
                py={3}
              >
                No scheduled time data available
              </Typography>
            ) : (
            <ChartBox
  id="wd-hourly"
  height={180}
  label="Service distribution chart"
  minWidth={
    groupBy === "daily" && m.chartLabels.length > 14
      ? m.chartLabels.length * 35
      : groupBy === "weekly" && m.chartLabels.length > 8
        ? m.chartLabels.length * 80
        : undefined
  }
/>
            )}
          </CardContent>
        </Card>

        {/* ── Row 3: Service Type | Status ── */}
        <Grid2 container spacing={1.5} sx={{ mb: 2 }}>
          <Grid2 size={{ xs: 12, md: 7 }}>
            <SectionCard
              title="Services by Type"
              icon={<MedicalServices />}
              color={C.teal}
              onViewAll={() =>
                setDialog({
                  open: true,
                  title: "All Service Types",
                  rows: m.serviceTypeTableRows,
                  columns: serviceCols,
                  csv: "service_types.csv",
                })
              }
            >
              {m.serviceTypeData.length === 0 ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  textAlign="center"
                  py={3}
                >
                  No data
                </Typography>
              ) : (
                <Box sx={{ mt: 1.5 }}>
                  {m.serviceTypeData.map(([name, count], i) => (
                    <Box key={name} sx={{ mb: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 0.3,
                        }}
                      >
                        <Typography
                          variant="caption"
                          fontWeight={i === 0 ? 600 : 400}
                          sx={{
                            maxWidth: "82%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {i + 1}. {name}
                        </Typography>
                        <Chip
                          label={count}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: svcColors[i % svcColors.length] + "22",
                            color: svcColors[i % svcColors.length],
                            fontWeight: 700,
                          }}
                        />
                      </Box>
                      <Box
                        sx={{
                          height: 5,
                          background: "#ebebeb",
                          borderRadius: 99,
                        }}
                      >
                        <Box
                          sx={{
                            width: `${Math.round((count / m.serviceTypeData[0][1]) * 100)}%`,
                            height: "100%",
                            background: svcColors[i % svcColors.length],
                            borderRadius: 99,
                            transition: "width 0.5s ease",
                          }}
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </SectionCard>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 5 }}>
            <SectionCard
              title="Services by Physician"
              icon={<PeopleOutline />}
              color={C.purple}
              onViewAll={() =>
                setDialog({
                  open: true,
                   title: "All Services by Physician",
                  rows: m.physicianTableRows,
                  columns: physicianCols,
                  csv: "physician_services.csv",
                })
              }
            >
              {m.physicianData.length === 0 ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  textAlign="center"
                  py={3}
                >
                  No data
                </Typography>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {m.physicianData.map(([name, d], i) => {
                    const phColors = [
                      C.purple,
                      C.blue,
                      C.teal,
                      C.coral,
                      C.amber,
                      C.pink,
                    ];
                    return (
                      <Box
                        key={name}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          px: 1.5,
                          py: 0.75,
                          borderRadius: 1.5,
                          background: "#f7f8fa",
                          border: "1px solid #ebebeb",
                        }}
                      >
                        <Box
                          sx={{
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            background: phColors[i % phColors.length] + "22",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <Typography
                            variant="caption"
                            fontWeight={700}
                            sx={{
                              color: phColors[i % phColors.length],
                              fontSize: "0.65rem",
                            }}
                          >
                            {i + 1}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          fontWeight={600}
                          sx={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {name}
                        </Typography>
                        <Chip
                          label={`${d.total} total`}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: phColors[i % phColors.length] + "22",
                            color: phColors[i % phColors.length],
                            fontWeight: 700,
                          }}
                        />
                        <Chip
                          label={`✓ ${d.completed}`}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: C.greenL,
                            color: C.green,
                            fontWeight: 600,
                          }}
                        />
                        <Chip
                          label={`▶ ${d.inProgress}`}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: C.blueL,
                            color: C.blue,
                            fontWeight: 600,
                          }}
                        />
                        <Chip
                          label={`⏳ ${d.notStarted}`}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: C.amberL,
                            color: C.amber,
                            fontWeight: 600,
                          }}
                        />
                      </Box>
                    );
                  })}
                </Box>
              )}
            </SectionCard>
          </Grid2>
        </Grid2>

        {/* ── Row 4: Physician breakdown ── */}
        {/* <Grid2 container spacing={1.5} sx={{ mb: 2 }}>
          <Grid2 size={{ xs: 12 }}>
            <SectionCard
              title="Services by Physician"
              icon={<PeopleOutline />}
              color={C.purple}
              onViewAll={() =>
                setDialog({
                  open: true,
                   title: "All Services by Physician",
                  rows: m.physicianTableRows,
                  columns: physicianCols,
                  csv: "physician_services.csv",
                })
              }
            >
              {m.physicianData.length === 0 ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  textAlign="center"
                  py={3}
                >
                  No data
                </Typography>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {m.physicianData.map(([name, d], i) => {
                    const phColors = [
                      C.purple,
                      C.blue,
                      C.teal,
                      C.coral,
                      C.amber,
                      C.pink,
                    ];
                    return (
                      <Box
                        key={name}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          px: 1.5,
                          py: 0.75,
                          borderRadius: 1.5,
                          background: "#f7f8fa",
                          border: "1px solid #ebebeb",
                        }}
                      >
                        <Box
                          sx={{
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            background: phColors[i % phColors.length] + "22",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <Typography
                            variant="caption"
                            fontWeight={700}
                            sx={{
                              color: phColors[i % phColors.length],
                              fontSize: "0.65rem",
                            }}
                          >
                            {i + 1}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          fontWeight={600}
                          sx={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {name}
                        </Typography>
                        <Chip
                          label={`${d.total} total`}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: phColors[i % phColors.length] + "22",
                            color: phColors[i % phColors.length],
                            fontWeight: 700,
                          }}
                        />
                        <Chip
                          label={`✓ ${d.completed}`}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: C.greenL,
                            color: C.green,
                            fontWeight: 600,
                          }}
                        />
                        <Chip
                          label={`▶ ${d.inProgress}`}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: C.blueL,
                            color: C.blue,
                            fontWeight: 600,
                          }}
                        />
                        <Chip
                          label={`⏳ ${d.notStarted}`}
                          size="small"
                          sx={{
                            height: 18,
                            fontSize: "0.62rem",
                            background: C.amberL,
                            color: C.amber,
                            fontWeight: 600,
                          }}
                        />
                      </Box>
                    );
                  })}
                </Box>
              )}
            </SectionCard>
          </Grid2>
        </Grid2> */}
      </Box>

      <DateRangeDialog
        key="wd-date"
        title="Dashboard Date Range"
        filters={filters}
        setFilters={setFilters}
        openState={openDateDlg}
        setOpenState={setOpenDateDlg}
      />

      <TableDialog
        open={dialog.open}
        onClose={closeDialog}
        title={dialog.title}
        rows={dialog.rows}
        columns={dialog.columns}
        csvFilename={dialog.csv}
        auth={auth}
        filters={filters}
      />
    </Box>
  );
}
